<template>
  <div class="footer-wrap">
    <div class="Apply">
      <p>共享配电房智能化改造，无人值守运维，在线能耗监测平台</p>
      <router-link to="/index/njb"><button>申请加入</button></router-link>
    </div>
    <div class="footer">
      <div class="edg_bottom">
        <div class="table">
          <div class="flex flex1">
            <div class="edg_bottom-title">关于我们</div>
            <ul>
              <li><router-link to="/index/qyjs">公司介绍</router-link></li>
              <li><router-link to="/index/xwdt">新闻动态</router-link></li>
              <li><router-link to="/index/lxwm">联系我们</router-link></li>
            </ul>
          </div>
          <div class="flex flex222">
            <div class="edg_bottom-title">服务条款</div>
            <ul>
              <li v-for="(fw, index) in fwtk" :key="index">
                <a :href="fw.fileUrl" target="_blank">{{ fw.title }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex222">
            <div class="edg_bottom-title">友情链接</div>
            <ul>
              <li v-for="(yq, index) in yqlj" :key="index">
                <a :href="yq.linkUrl" target="_blank">{{ yq.linkName }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex333">
            <div class="edg_bottom-title">技术文档</div>
            <ul>
              <li v-for="(js, index) in jswd" :key="index">
                <a :href="js.fileUrl" target="_blank">{{ js.title }}</a>
              </li>
            </ul>
          </div>
          <div class="flex flex2">
            <div class="edg_bottom-title">投诉咨询</div>
            <ul class="imglogo">
              <li class="tel">4008-263-365</li>
              <li class="tel">投诉电话</li>
              <li class="tel">0571-86779590</li>
              <li class="erweima">
                <!-- <img src="../../assets/img/erweima-logo2.jpg" alt="" class="ewcode"> -->
              </li>
            </ul>
          </div>
          <div class="flex flex2">
            <div class="edg_bottom-title">关注我们</div>
            <ul class="imglogo">
              <li class="erweima">
                <img
                  src="../../assets/img/微信图片_20200430092314.jpg"
                  alt=""
                  class="ewcode"
                />
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="line"></div> -->
        <div class="edg_record">
          <div>
            备案信息：浙B2-20090014 || 中国 • 杭州湖墅南路332号新能量大楼
          </div>
          <div>
            Copyright © 2004 Freshpower.cn.All rights Reserved | 新能量 |
            能监宝-智能能源监测平台
          </div>
          <div>
            <div>
              <p class="icon-public"></p>
              <a
                href=" http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502002132"
                target="_blank"
                >公安备案号：33010502002132</a
              >
            </div>
            <div>
              <p class="icon-gxb"></p>
              <a href="http://www.beian.miit.gov.cn/" target="_blank"
                >工信部备案号：浙B2-20090014-4</a
              >
            </div>
          </div>
          <div>网站运营：浙江新能量科技股份有限公司</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "homefot",
  data() {
    return {
      fwtk: "",
      jswd: "",
      fileId: "",
      yqlj: ""
    };
  },
  mounted() {
    this.fwtkInfo();
    this.jswdInfo();
    this.yqljInfo();
  },
  methods: {
    // 服务条款
    fwtkInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalContent?pageIndex=1&pageSize=4&columnId=0a59dc8e54d54d6ea73142c666fd08df`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.fwtk = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    },
    // 技术文档
    jswdInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalContent?pageIndex=1&pageSize=4&columnId=b298ada29c6b45ab884adbd081a341a7`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.jswd = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    },
    // 友情链接
    yqljInfo() {
      axios
        .post(
          `${this.global.baseUrl}/news/listPortalLink?pageIndex=1&pageSize=4`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            this.yqlj = response.data.data.items;
          } else if (response.data.code === 0) {
            this.$message.info(response.data.msg);
          } else if (response.data.code === -1) {
            this.$message.error(response.data.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
.footer-wrap {
  position: relative;
  background-image: url("../../assets/img/home-fot.jpg");
  width: 100%;
  /* height: 1000px; */
  height: 100%;
  background-size: cover;
}

.footer {
  position: absolute;
  bottom: 0px;
}

/* 合作申请 */
.Apply {
  /* height: 300px; */
  padding: 130px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
}

.Apply > p {
  height: 50px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
}

.Apply > a > button {
  display: block;
  z-index: 50;
}

.Apply > a > button {
  border: none;
  width: 140px;
  height: 40px;
  background: rgba(76, 148, 253, 1);
  border-radius: 2px;
  margin-top: 48px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}
.line {
  margin: 10px auto 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/homefot.vue